export enum USAGE_METRICS {
	USER_ACTIVITY = 'user_activity'
}
